import { render, staticRenderFns } from "./salesTrashed.vue?vue&type=template&id=649ffafb&scoped=true&"
import script from "./salesTrashed.vue?vue&type=script&lang=js&"
export * from "./salesTrashed.vue?vue&type=script&lang=js&"
import style0 from "./salesTrashed.vue?vue&type=style&index=0&lang=css&"
import style1 from "./salesTrashed.vue?vue&type=style&index=1&id=649ffafb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649ffafb",
  null
  
)

export default component.exports